import { useEffect, useState } from 'react';

import { CustomerState } from '../../../api/lending/edge';

type FormType = 'BASE' | 'SOLE_TRADER';

export function useFormType({
  customerState,
}: {
  customerState: CustomerState;
}): FormType {
  const [formType, setFormType] = useState<FormType>('BASE');

  useEffect(() => {
    /**
     * Unpacks customerState variable and extracts the company type
     */
    const retrieveCompanyTypeFromCustomerState = () => {
      const company = customerState?.application?.company;
      const companyType = company?.type;

      if (
        companyType === 'limited_liability_company' ||
        companyType === 'limited_liability_partnership' ||
        companyType === 'public_limited_company'
      ) {
        setFormType('BASE');
      } else if (
        companyType === 'sole_trader' ||
        companyType === 'ordinary_partnership' ||
        companyType === 'other'
      ) {
        setFormType('SOLE_TRADER');
      }
    };

    retrieveCompanyTypeFromCustomerState();
  }, [customerState]);

  return formType;
}
